let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cGQGY")).then(() => parcelRequire('77zn3'));